// TODO: zvazit, ci z tohto neurobit exportovane konstanty (a potom rovnako urobit aj scratchcards)
export const COMMUNITY_PATHS = {
    COMMUNITY_CONDITIONS: {
        path: '/komunita/podmienky',
        name: 'betbook:conditions'
    },
    COMMUNITY_FAQ: {
        path: '/komunita/faq',
        name: 'betbook:faq'
    },
    COMMUNITY_NEW_ANALYSIS_FROM_TICKET: {
        path: '/komunita/analyzy/nova/:betId/:ticketId?',
        name: 'betbook:newAnalysis:fromTicket'
    },
    COMMUNITY_NEW_ANALYSIS: {
        path: '/komunita/analyzy/nova',
        name: 'betbook:newAnalysis'
    },
    COMMUNITY_EDIT_ANALYSIS: {
        path: '/komunita/analyzy/:postId/uprava',
        name: 'betbook:editAnalysis'
    },
    COMMUNITY_ANALYSIS_DETAIL: {
        path: '/komunita/analyzy/:postId/:postUrlSuffix',
        name: 'betbook:analysisDetail'
    },
    COMMUNITY_ANALYSES: {
        path: '/komunita/analyzy',
        name: 'betbook:analyses'
    },
    COMMUNITY_NEW_TICKET_FROM_TICKET_HASH: {
        path: '/komunita/tikety/novy/:ticketHash',
        name: 'betbook:newTicket:fromTicketHash'
    },
    COMMUNITY_NEW_TICKET: {
        path: '/komunita/tikety/novy',
        name: 'betbook:newTicket'
    },
    COMMUNITY_EDIT_TICKET: {
        path: '/komunita/tikety/:postId/uprava',
        name: 'betbook:editTicket'
    },
    COMMUNITY_TICKET_DETAIL: {
        path: '/komunita/tikety/:postId/:postUrlSuffix',
        name: 'betbook:ticketDetail'
    },
    COMMUNITY_TICKETS: {
        path: '/komunita/tikety',
        name: 'betbook:tickets'
    },
    COMMUNITY_POSTS_AUTHOR: {
        path: '/komunita/autori/:nickname/:postType?',
        name: 'betbook:post:author'
    },
    COMMUNITY_TOP_EVENTS: {
        path: '/komunita/top-podujatia/:sport?/:time?',
        name: 'betbook:top:events'
    },
    COMMUNITY_LOBBY: {
        path: '/komunita',
        name: 'betbook:lobby'
    }
} as const;
